function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: #626a84;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: none;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Menu:_Student_List",
  "data-name": "Menu: Student List",
  transform: "translate(-35 -401.558)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_661",
  "data-name": "Path 661",
  className: "cls-1",
  d: "M0,0A10.5,10.5,0,0,1,10.5,10.5,10.5,10.5,0,0,1,0,21",
  transform: "translate(43 426.058) rotate(-90)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_662",
  "data-name": "Path 662",
  className: "cls-1",
  d: "M6.758,0A6.355,6.355,0,0,1,7,1.83a7,7,0,0,1-7,7",
  transform: "translate(62.17 426.058) rotate(-90)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_663",
  "data-name": "Path 663",
  className: "cls-1",
  d: "M6.758,8.83A6.355,6.355,0,0,0,7,7,7,7,0,0,0,0,0",
  transform: "translate(36 426.442) rotate(-90)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_165",
  "data-name": "Ellipse 165",
  className: "cls-1",
  transform: "translate(47.667 401.558)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 5.833,
  cy: 5.833,
  r: 5.833
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 5.833,
  cy: 5.833,
  r: 4.833
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_166",
  "data-name": "Ellipse 166",
  className: "cls-1",
  transform: "translate(60.5 409.725)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 3.5,
  cy: 3.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 3.5,
  cy: 3.5,
  r: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_167",
  "data-name": "Ellipse 167",
  className: "cls-1",
  transform: "translate(39.5 409.725)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 3.5,
  cy: 3.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 3.5,
  cy: 3.5,
  r: 2.5
})));

var SvgSideStudentLists = function SvgSideStudentLists(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 25.884",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSideStudentLists, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/side-student-lists.465327be.svg";
export { ForwardRef as ReactComponent };